export const processPageMeta = (item): { description: string | null; image: string | null } => {
    const meta = {
        description: null,
        image: null,
    };

    if (item.item_type.Link.meta) {
        item.item_type.Link.meta.map((metaItem) => {
            if (metaItem.property) {
                switch (metaItem.property.toLowerCase()) {
                    case 'og:image':
                        meta.image = metaItem.content;
                        break;
                    case 'description':
                        meta.description = metaItem.content;
                        break;
                }
            }
        });
    }
    return meta;
};
